module.exports = __webpack_public_path__ + "img/CRC2_CD8T.8b6026ba.png";